export default __webpack_public_path__ + "static/media/image-44.b83728de.png";